// Shared calendar constants + date math used by ClientCalendarPage,
// MasterCalendarPage and ActivityDialog.

export const STATUS_META = {
  planned:            { label: "Planned",            color: "#71717A", bg: "#F4F4F5" },
  in_progress:        { label: "In progress",        color: "#0369A1", bg: "#E0F2FE" },
  ready_for_signoff:  { label: "Awaiting sign-off",  color: "#A16207", bg: "#FEF3C7" },
  approved:           { label: "Approved",           color: "#15803D", bg: "#DCFCE7" },
  posted:             { label: "Posted",             color: "#1E40AF", bg: "#DBEAFE" },
  revise:             { label: "Revisions requested", color: "#9333EA", bg: "#F3E8FF" },
  rejected:           { label: "Rejected",           color: "#B91C1C", bg: "#FEE2E2" },
};

export function startOfMonth(d) { return new Date(d.getFullYear(), d.getMonth(), 1); }
export function addMonths(d, n) { return new Date(d.getFullYear(), d.getMonth() + n, 1); }
export function isoDate(d) {
  // YYYY-MM-DD in local time (matches calendar day cells)
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function buildMonthGrid(anchorDate) {
  // Returns a 6-row × 7-col grid of Date objects (Mon-start week).
  const first = startOfMonth(anchorDate);
  const dow = (first.getDay() + 6) % 7;  // 0=Mon
  const start = new Date(first);
  start.setDate(first.getDate() - dow);
  const days = [];
  for (let i = 0; i < 42; i++) {
    const d = new Date(start);
    d.setDate(start.getDate() + i);
    days.push(d);
  }
  return days;
}

export const WEEKDAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export function combineDateTime(dayIso, timeStr) {
  // dayIso = YYYY-MM-DD, timeStr = HH:MM → "YYYY-MM-DDTHH:MM:00"
  const t = (timeStr || "09:00").padEnd(5, "0");
  return `${dayIso}T${t}:00`;
}

export function splitDateTime(iso) {
  if (!iso) return { day: "", time: "09:00" };
  return { day: iso.slice(0, 10), time: iso.slice(11, 16) || "09:00" };
}
